export const USER_ROLES = {
    CLIENT_READONLY: 'clientreadonly',
    CLIENT: 'client',
    CONSULTANT: 'consultant',
    WHITELABEL_ADMIN: 'whitelabeladmin',
    WHITELABEL_MASTER: 'whitelabelmaster',
    OWNER_OF_BUSINESS: 'ownerofbusiness',
    NETWORK_ADMIN: 'networkadmin',
  } as const;

/** Roles that must not open the buy basket while acting as themselves. */
export const CART_BLOCKED_ROLES: readonly string[] = [
  USER_ROLES.CONSULTANT,
  USER_ROLES.WHITELABEL_ADMIN,
  USER_ROLES.OWNER_OF_BUSINESS,
  USER_ROLES.NETWORK_ADMIN,
];

export function isCartBlockedRole(
  roles: string[] | null | undefined,
): boolean {
  if (!roles || roles.length === 0) return false;
  return CART_BLOCKED_ROLES.some((role) => roles.includes(role));
}

/**
 * Cart lock for the current portal session.
 *
 * Matches existing WL behaviour for consultant / WL admin / owner:
 * - blocked while those roles are the *current* JWT role
 * - allowed after Login As client (current role becomes client)
 *
 * Network admin is the exception: Login As is read-only, so if the
 * impersonator was networkadmin, cart stays blocked even as client.
 */
export function isCartBlockedSession(accountDetails: {
  role?: string[] | null;
  impersonatorRoles?: string[] | null;
} | null | undefined): boolean {
  if (!accountDetails) return false;
  if (isCartBlockedRole(accountDetails.role)) return true;

  const impersonatorRoles = accountDetails.impersonatorRoles || [];
  return impersonatorRoles.includes(USER_ROLES.NETWORK_ADMIN);
}
